<!--
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-09-11 15:37:15
 * @FilePath: \gcp-fe\src\app\shop\components\shopHead.vue
 * @Description: 首页头部--搜索
-->
<template>
  <div class="head clearfix searchBox">
    <div class="content clearfix">
      <div class="logo fl">
        <router-link to="/">
          <!--<svg-icon icon-class="logo"></svg-icon>-->
          <img
            style="width: 204px;height: 68px;"
            :src="require('@/basa/assets/images/logo0.png')"
          />
        </router-link>
      </div>
      <div class="search fl">
        <el-select
          class="search-select fl"
          v-model="value"
          :placeholder="$t('shopHead.selectPlc')"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-input
          class="search-input fl"
          v-model="name"
          clearable
          :placeholder="
            value == 1
              ? $t('shopHead.options.searchPlcOne')
              : value == 2
              ? $t('shopHead.options.searchPlcTwo')
              : $t('shopHead.options.searchPlcThree')
          "
        ></el-input>
        <el-button type="text" class="search-btn fl" @click="search">{{
          $t("shopHead.searchBtn")
        }}</el-button>
      </div>

      <!-- 暂时不上 -->
      <!-- <div class="xuqiu" @click="faxuqiu">
        <span class="xuqiu-left"></span>
        <span class="xuqiu-cont">发布需求</span>
      </div>
      <div class="clearfix"></div> -->
    </div>
  </div>
</template>

<script>
import store from "@/config/store";
import { mixinHomePage } from "../../../mixins/mixin-common/mixin-homePage";
import { addUrlPerFix } from "@/basa/utils";

export default {
  name: "shopHead",
  mixins: [mixinHomePage],

  data() {
    return {
      activeIndex: "0",
      value: this.$route.query.type == 4 ? "2" : "1",
      placeholder: this.$t("shopHead.dataPlaceholder"),
      options: [
        {
          label: this.$t("shopHead.options.labelOne"),
          value: "1"
        },
        {
          label: this.$t("shopHead.options.labelTwo"),
          value: "2"
        },
        {
          label: this.$t("shopHead.options.labelThree"),
          value: "3"
        }
      ],
      brandList: [
        {
          name: this.$t("shopHead.brandList.menuOne"), //首页
          type: 1,
          activeIndex: "0",
          to: "/",
          show: true
        },
        {
          name: this.$t("shopHead.brandList.menuTwo"), //物资设备采购
          type: 3,
          activeIndex: "2"
          // show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("shopHead.brandList.menuThree"), //工程专区
          type: 2,
          activeIndex: "1"
          // show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("shopHead.brandList.menuFour"), //商城采购
          type: 4,
          activeIndex: "3"
          // show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("shopHead.brandList.menuFive"), //资源共享
          type: 5,
          activeIndex: "4"
          // show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("shopHead.brandList.menuSix"), //运输物流
          type: 6,
          activeIndex: "5"
          // show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("shopHead.brandList.menuSeven"), //智慧云仓
          type: 7,
          activeIndex: "6"
          // show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("shopHead.brandList.menuEight"), //供应链金融
          type: 8,
          activeIndex: "7"
          // show: !!Cookies.get("access_token")
        },
        {
          name: this.$t("shopHead.brandList.menuNine"), //车辆专区 //车辆专区
          type: 9,
          activeIndex: "8"
          // show: !!Cookies.get("access_token")
        }
        // {
        //   name: "合作商", //合作商 (本期暂时不上)
        //   type: 9,
        //   activeIndex: "8"
        //   // show: !!Cookies.get("access_token")
        // }
      ],
      // name: this.$route.query.name || ""
      name: sessionStorage.getItem("searchName") || ""
    };
  },
  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.name = "";
        }
      }
    },
    $route() {
      if (this.$route.path != "/procurementNotice") {
        this.name = "";
      }
    },
    name: {
      handler(newVal) {
        sessionStorage.setItem("searchName", newVal);
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.activeIndex = this.$route.path === "/" ? 0 : 2;
  },
  methods: {
    search() {
      store.dispatch("setPageLoading", true);

      // 添加路由跳转后的处理
      const removeAfterEach = this.$router.afterEach(() => {
        store.dispatch("setPageLoading", false);
        removeAfterEach(); // 移除监听器
      });

      if (this.value == 1) {
        this.$router.push({
          path: "/procurementNotice",
          query: {
            name: this.name,
            v: Math.random()
          }
        });
        // window.open(
        //   `/procurementNotice?name=${this.name}&v=${Math.random()}`,
        //   "_self"
        // );
        // 跳转中交供应商门户搜索页: sp.iccec.cn
        // location.href = `/searchList?name=${this.name}&v=${Math.random()}`;
      } else if (this.value == 2) {
        // 跳转中交供应商门户搜索页: sp.iccec.cn
        // location.href = `${this.$addUrlPerFix(
        //   process.env.VUE_APP_SP_URL
        // )}/announcementsList?type=4&source=1&name=${
        //   this.name
        // }&v=${Math.random()}&isJRZL=1&searchType=${bpBread[this.activeIndex]}`;
        // window.open(
        //   `/procurementNotice?type=4&source=1&name=${
        //     this.name
        //   }&v=${Math.random()}`,
        //   "_self"
        // );
        this.$router.push({
          path: "/procurementNotice",
          query: {
            name: this.name,
            type: 4,
            source: 1,
            v: Math.random()
          }
        });
      } else if (this.value == 3) {
        // 跳转交建云商商品搜索页面: emos.iccec.cn
        location.href = `${this.$addUrlPerFix(
          process.env.VUE_APP_EMOS_URL
        )}?keyWord=${this.name ? this.name : "安全帽"}&orgId=${
          this.$store.getters.getLoginInfo.orgId
        }`;
        store.dispatch("setPageLoading", false);
      }
    },
    showFilter(list) {
      let newList = list.filter(item => {
        return item.show === true;
      });
      return newList;
    },
    handleClick(item) {
      if (item.type === 2) {
        // 跳转分包电子采购共享平台首页: scp.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_SCP_URL)}`;
      }
      if (item.type === 3) {
        // 跳转中交供应商门户首页: sp.iccec.cn
        this.activeIndex = 2;
        this.$router.push({
          path: "/procurementNotice"
        });
        // location.href=(`${this.$addUrlPerFix(process.env.VUE_APP_SP_URL)}`);
      }
      if (item.type === 4) {
        // 跳转交建云商专区首页: emp.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_EMP_URL)}`;
      }
      if (item.type === 5) {
        // 跳转中交资源共享专区首页: clp.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_YZ_URL)}`;
      }
      if (item.type === 6) {
        // 跳转运输物流专区首页: wuliuyun.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_WLY_URL)}`;
      }
      if (item.type === 7) {
        // 跳转智慧云仓专区首页: yuncang.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_YC_URL)}`;
      }
      if (item.type === 8) {
        // 跳转供应链金融专区首页: jr.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_JR_URL)}`;
      }
      if (item.type === 9) {
        // 跳转车辆专区首页: clzl.iccec.cn
        location.href = `${this.$addUrlPerFix(process.env.VUE_APP_CLZL_URL)}`;
      }
    },
    // 发布需求
    async faxuqiu() {
      if (this.$store.getters.getLoginInfo.name) {
        // showFlag({ agentId: "100013" }).then(res => {
        //   if (res.data.data == true) {
        //     window.location.href = `${addUrlPerFix(
        //       process.env.VUE_APP_MOA_URL
        //     )}/requirement-publishing/new-demand?a=100021`;
        //   } else if (res.data.data == false) {
        //     this.$confirm("该功能仅为采购组织用户提供！", "提示", {
        //       dangerouslyUseHTMLString: true,
        //       showCancelButton: false,
        //       customClass: "message-box-faxuqiu",
        //       message:
        //         '<div style="font-size: 16px;">该功能仅为采购组织用户提供！</div>'
        //     });
        //   }
        // });
        // 去掉提示 直接跳转
        window.location.href = `${addUrlPerFix(
          process.env.VUE_APP_MOA_URL
        )}/requirement-publishing/new-demand?a=100021`;
      } else {
        // window.location.href = `${addUrlPerFix(
        //     process.env.VUE_APP_MOA_URL
        //   )}/requirement-publishing/new-demand?a=100021`;
        // }
        window.location.href =
          this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
          "?redirectUrl=" +
          encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_BASE_URL));
      }
    }
  },
  computed: {
    catalogList() {
      return store.state.user.catalogList;
    },
    hoverClass() {
      if (!store.state.user.isPortal) {
        return "catalog-info-hover";
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.searchBox {
  padding: 20px;
}
.el-input /deep/ input.el-input__inner {
  border: none !important;
}

.svg-icon {
  width: 100% !important;
  height: 68px !important;
}

.el-menu-item:focus,
.el-menu-item:hover {
  background-color: inherit;
}
.line-hight {
  color: #0089ef;
}
/deep/.search {
  position: relative;
}
/deep/.search-btn {
  position: absolute;
  right: 0;
  padding: 11px 20px;
}

/deep/ .el-input__icon:after {
  width: 0 !important;
}
</style>
